<template>
  <vlt-modal
    :visible="visible"
    canCancel
     :okText="$t('message.delete')"
     :cancelText="$t('message.cancel')"
     :title="$t('message.dashboard.editUser.delete_user')"
     @close="$emit('onClose')"
     @confirm="doDelete"
      :noFooter="!!deleting"
    message
    confirmBtnIcon="bin"
    destructive
  >
    <!--NAME-->
    <div class="Vlt-grid">
      <div class="Vlt-col Vlt-col--center">
        {{$t('message.dashboard.editUser.confirm_delete',{userName: selectedUser['caller_name']})}}
      </div>

    </div>

    <div v-if="deleting" class="Vlt-col Vlt-col--center">
      <vlt-spinner small></vlt-spinner>
    </div>
    <vlt-callout
      v-if="error"
      dismissable
      @dismissed="error = null"
      type="critical"
    >
      <h5>{{$t('message.errors.failed_to_delete_user')}}</h5>
    </vlt-callout>

  </vlt-modal>
</template>

<script>
import {
  VltModal,
  VltSpinner,
  VltCallout,
} from '@vonagevolta/vue';
import EventBus from 'Utils/event-bus';


export default {
  name: 'DeleteUserModal',
  components: {
    VltModal,
    VltSpinner,
    VltCallout,
  },
  data() {
    return {
      deleting: false,
      error: null,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    selectedUser: {
      type: Object,
      required: true,
    },
    onDeleteUser: {
      type: Function,
      required: true,
    },

  },
  methods: {
    async doDelete() {
      this.deleting = true;

      if (!this.selectedUser.phone) {
        this.$emit('onClose');
      } else {
        try {
          this.onDeleteUser(this.selectedUser);
          EventBus.$emit('reloadUsers');
          this.$emit('onClose');
        } catch (err) {
          this.error = true;
        }
        this.deleting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .info-line {
    display: flex;
    justify-content: space-between;

    .label {
      flex: 1 1 0;
      white-space: nowrap;
    }

    .value {
      flex: 2 1 100%;
      text-align: right;
      overflow: hidden;
      white-space: nowrap;

      li {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
